import { Box, Icon } from '../widgets'
import './SettingsBackButton.scss'

export const SettingsBackButton = ({ onClick, mobileOnly }) => (
  <Box
    className={`back-button-container ${mobileOnly ? 'mobile-only' : ''}`}
    position="absolute"
    cursor="pointer"
    onClick={onClick}
  >
    <Icon icon="LeftArrow" fill="black"/>
  </Box>
)